import React, { useContext, useEffect, useState } from 'react'
import Navbar from '../../../Components/Navbar/Navbar'
import Footer from '../../../Components/Footer/Footer'
import Style from './Style.module.css'
import instance from '../../../instance/AxiosInstance'
import { UserContext } from '../../../Contexts/UserContext'
import SubscriptionCarousel from '../../../Components/Carousels/SubscriptionCarousel/SubscriptionCarousel'
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const PurchaseAd = () => {
    const { t } = useTranslation()
    const loggedInUser = useContext(UserContext);
    const { User } = loggedInUser

    const [Subscriptions, SetSubscriptions] = useState([])
    const [UserData, SetUserData] = useState({})
    const [userPostCount, setUserPostCount] = useState(0)

    const location = useLocation();
    const pathSegment = location.pathname.split('/').filter((segment) => segment);

    // Fetch subscription plans
    useEffect(() => {
        instance.get('/api/user/subscription_plans/get_live_subscription')
            .then((response) => {
                const resData = response.data;

                const sortedData = resData.sort((a, b) => {
                    const priceA = parseFloat(a.monthly_pricing);
                    const priceB = parseFloat(b.monthly_pricing);
                    return priceA - priceB;
                });

                SetSubscriptions([...sortedData]);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    // Fetch user profile and post count
    useEffect(() => {
        try {
            instance.get(`/api/user/profile/get_profile/${User._id}`)
                .then((Response) => {
                    const userData = Response.data;
                    SetUserData({ ...userData });
                    
                    // Extract post count from user data (AdCount)
                    setUserPostCount(userData.AdCount || 0);
                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
            console.log(error);
        }
    }, [User]);

    return (
        <>
            <Navbar />
            <div className={Style.mainContainer}>
                <Breadcrumb pathSegments={pathSegment} />
                <div className={Style.Container}>

                    <div className={Style.top}>
                        <div className={Style.top_row}>
                            <h1>
                                {t("Wegota_plan")} <br />{t("thats_perfect")}
                            </h1>
                            <p className={Style.unlock_info}>
                                🎯 Post more ads to unlock premium plans for FREE!
                            </p>
                        </div>
                        <div className={Style.bottom_row}>
                            <div className={Style.ad_count_card}>
                                <span className={Style.First}>
                                    {t("remaining_ad_count")}
                                </span>
                                <span className={Style.Second}>
                                    {UserData ? UserData.AdCount : 0}
                                </span>
                            </div>
                            <div className={Style.unlock_milestones}>
                                <div className={Style.milestone}>
                                    <span className={Style.milestone_icon}>🥈</span>
                                    <div className={Style.milestone_text}>
                                        <strong>Silver:</strong> 10 posts
                                    </div>
                                </div>
                                <div className={Style.milestone}>
                                    <span className={Style.milestone_icon}>🥇</span>
                                    <div className={Style.milestone_text}>
                                        <strong>Golden:</strong> 20 posts
                                    </div>
                                </div>
                                <div className={Style.milestone}>
                                    <span className={Style.milestone_icon}>💎</span>
                                    <div className={Style.milestone_text}>
                                        <strong>Platinum:</strong> 40 posts
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={Style.bottom}>
                        <div className={Style.row_bottom}>
                            <SubscriptionCarousel 
                                Subscriptions={Subscriptions} 
                                userPostCount={userPostCount}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <Footer />
        </>
    )
}

export default PurchaseAd